module.exports = __webpack_public_path__ + "img/930cc25.png";